<template>

  <div
    class="modal adapted-meet-max-width"
    tabindex="-1"
    role="dialog"
    @click.self="close">
    <div
      class="modal-dialog"
      role="document"
      :style="{'max-width': maxWidth}">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div
          class="modal-body"
          :style="{'min-height': minHeight}">
          <slot name="body"></slot>
        </div>
        <div class="modal-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'Modal',
  components: {
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    minHeight: {
      type: String,
      default: '50px'
    },
    maxWidth: {
      type: String,
      default: '500px'
    }
  },
  computed: {
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal{
  display: block;
  background: rgb(0,0,0,0.7);
  padding: 20px;
  cursor: default;
}
.modal-dialog {
  height: 100%;
  max-height: calc(100% - 40px);
}
.modal-content {
  max-height: 100%;
}
.modal-body {
  overflow: auto;
  max-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Modal/Modal.vue